import React from 'react';
import Carousel from 'react-bootstrap/Carousel';

const Slider = () => (
  <Carousel className="carousel">
    <Carousel.Item className="carousel-item">
      <img
        src="https://images.unsplash.com/photo-1629909613654-28e377c37b09?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Y2xpbmljfGVufDB8fDB8fA%3D%3D&w=1000&q=80"
        className="d-block w-100"
        alt="travel vacation"
      />
    </Carousel.Item>
    <Carousel.Item className="carousel-item">
      <img
        src="https://e-clinic.co.uk/wordpress_new/wp-content/uploads/2021/09/Image-14-09-2021-at-13.59.jpg"
        className="d-block w-100"
        alt="travel vacation"
      />
    </Carousel.Item>
    <Carousel.Item className="carousel-item">
      <img
        src="https://firstmedcenters.com/wp-content/uploads/2022/07/English-speaking-clinic-FirstMed-V2-2.jpg"
        className="d-block w-100"
        alt="travel vacation"
      />
    </Carousel.Item>
    <Carousel.Item className="carousel-item">
      <img
        src="https://www.extraspace.com/blog/wp-content/uploads/2020/10/preparing-home-for-airbnb.jpg"
        className="d-block w-100"
        alt="travel vacation"
      />
    </Carousel.Item>
    <Carousel.Item className="carousel-item">
      <img
        src="https://img1.wsimg.com/isteam/stock/4810/:/cr=t:0%25,l:5.83%25,w:88.34%25,h:100%25"
        className="d-block w-100"
        alt="travel vacation"
      />
    </Carousel.Item>
    <Carousel.Item className="carousel-item">
      <img
        src="https://healthwaymedical.com/wp-content/uploads/2022/01/Medico-Clinic-Surgery-1024x681.jpg"
        className="d-block w-100"
        alt="travel vacation"
      />
    </Carousel.Item>
    <Carousel.Item className="carousel-item">
      <img
        src="https://www.carepointmedical.com.au/wp-content/uploads/2020/08/doctors_three.jpg"
        className="d-block w-100"
        alt="travel vacation"
      />
    </Carousel.Item>
  </Carousel>
);

export default Slider;
